import React from 'react';
import { useTranslation } from 'react-i18next';
import omit from 'lodash/omit';
import { useCreateTransport } from 'api/transports/use-create-transport';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { FormDrawerWithButton } from 'components/common/form-drawer-with-button';
import { TransportForm } from 'components/transport/transport-form';
import type { ITransportFormFields } from 'components/transport/transport-form';

const TransportCreateComponent: React.FC = () => {
  const { t } = useTranslation();

  const { mutateAsync: createTransport, isLoading } = useCreateTransport();

  const handleFinish = async (values: ITransportFormFields) => {
    const apiVariables = {
      ...omit(values, ['subcontractor']),
      defaultCostPerKm: values.defaultCostPerKm,
      subcontractorId: values.subcontractor?.value ?? null,
    };

    await createTransport(apiVariables);
  };

  return (
    <FormDrawerWithButton
      formComponent={TransportForm}
      title={t('transport:add_transport')}
      buttonLabel={t('transport:add_transport')}
      isLoading={isLoading}
      onFinish={handleFinish}
    />
  );
};

export const TransportCreate = withRoleGuard(TransportCreateComponent, [UserRole.admin]);
